import { ServiceUtil } from "./services.util";

export const UserBasisApi = {
    getResidentialBasis,
    saveResidentialBasis,
    getFinancialBasis,
    saveFinancialBasis,
    saveUserBasis
}

function getResidentialBasis(){
    return ServiceUtil.executeServiceCall("LeadAPI",
        "api/UserBasis/GetResidentialBasis", ServiceUtil.getRequest());
}

function saveResidentialBasis(model) {
    return ServiceUtil.executeServiceCall("LeadAPI",
        "api/UserBasis/SaveResidentialBasis", ServiceUtil.postRequest(model));
}

function getFinancialBasis() {
    return ServiceUtil.executeServiceCall("LeadAPI",
        "api/UserBasis/GetFinancialBasis", ServiceUtil.getRequest());
}

function saveFinancialBasis(model) {
    return ServiceUtil.executeServiceCall("LeadAPI",
        "api/UserBasis/SaveFinancialBasis", ServiceUtil.postRequest(model));
}

function saveUserBasis(model){
    return ServiceUtil.executeServiceCall("LeadAPI",
        "api/UserBasis/Save", ServiceUtil.postRequest(model));
}


// WEBPACK FOOTER //
// ./src/_services/userBasis.service.js